import React from 'react'

import InputField14s from '../../CommonUtils/InputFeild14s'

const MessageA14s = (props) => {
  return (
    <div>
      <InputField14s {...props} />
    </div>
  )
}

export default MessageA14s
